import authApi from "../../api/authApi";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userLogin } from "../../features/userSlice";

const useLogin = (queryIdentifier) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const loginUser = async (reqBody) => {
    const res = await authApi.post("/auth/login", reqBody);
    const {
      accessToken,
      userRole,
      userName,
      servicerId,
      userEmail,
      servicerMasterName,
      trsiiOptIn,
      optOutFlag,
      servicerCoordinatorName,
    } = res.data;
    dispatch(
      userLogin({
        accessToken,
        userName,
        userRole,
        servicerId,
        userEmail,
        servicerMasterName,
        trsiiOptIn,
        optOutFlag,
        servicerCoordinatorName,
      })
    );
  };

  return useMutation(queryIdentifier, loginUser, {
    onError: (e) => {
      toast.error("Email or password NOT correct");
    },
  });
};

export default useLogin;
